
































































































































































































































import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import { Exhibitor } from '@/models/exhibitor';
import { isEmptyObject, searchItems, keys } from '@/utils/helpers';
import { orderBy, find } from 'lodash';

type Many<T> = T | ReadonlyArray<T>;

export default Vue.extend({
  name: 'exhibitor-list',
  metaInfo() {
    return {
      title: 'Exhibitor'
    };
  },
  data() {
    return {
      itemsPerPageArray: [2, 4, 8, 12, 25, 50],
      itemsPerPage: 8,
      list_type: 0,
      page: 1,
      searchQuery: '',
      orders: 'asc' as Many<boolean | 'asc' | 'desc'>,
      sort: 'updated_at' as string,
      sortItems: [
        { text: 'Updated At', value: 'updated_at' },
        { text: 'Created At', value: 'created_at' },
        { text: 'Name', value: 'name' }
      ],
      serverItemsLength: -1
    };
  },

  computed: {
    ...mapState('exhibitors', {
      exhibitors: 'exhibitors',
      exhibitorLoading: 'loading',
      exhibitorError: 'error'
    }),
    orderedExhibitors(): Exhibitor[] {
      // Use orderBy with advances sorting
      return searchItems<Exhibitor>(
        orderBy<Exhibitor>(this.exhibitors, [this.sort], this.orders),
        this.searchQuery.trim()
      );
    },
    itemsLength(): number {
      /* want to change length to be coming from server response pagination
      {
        count: # as number
        results: {} as Exhibitor[]
      }
      */
      return this.orderedExhibitors.length;
    },
    numberOfPages(): number {
      return Math.ceil(this.itemsLength / this.itemsPerPage);
    },
    pageStart(): number {
      // might have tio be exhibitors length not ordered exhibitors
      if (this.itemsPerPage === -1 || !this.exhibitors.length) return 0;

      return (this.page - 1) * this.itemsPerPage;
    },
    pageStop(): number {
      if (this.itemsPerPage === -1) return this.itemsLength;
      // might have tio be exhibitors length not ordered exhibitors
      if (!this.exhibitors.length) return 0;

      return Math.min(this.itemsLength, this.page * this.itemsPerPage);
    },
    paginatedItems(): Exhibitor[] {
      return this.paginateItems(this.orderedExhibitors);
    }
  },

  methods: {
    isEmptyObject,
    ...mapActions({
      fetchExhibitors: 'exhibitors/fetchExhibitors',
      fetchCategories: 'exhibitors/fetchCategories',
      deleteExhibitor: 'exhibitors/deleteExhibitor',
      createExhibitor: 'exhibitors/createExhibitor',
      createSnack: 'snackbar/createSnack'
    }),
    toggleOrder() {
      if (this.orders === 'asc') {
        this.orders = 'desc';
      } else {
        this.orders = 'asc';
      }
    },
    paginateItems(items: Exhibitor[]): Exhibitor[] {
      // Make sure we don't try to display non-existant page if items suddenly change
      // TODO: Could possibly move this to pageStart/pageStop?
      if (this.serverItemsLength === -1 && items.length <= this.pageStart) {
        this.page = Math.max(1, this.page - 1);
      }

      return items.slice(this.pageStart, this.pageStop);
    },
    nextPage(page: number) {
      if (this.page + 1 <= this.numberOfPages) this.page = page;
    },
    formerPage(page: number) {
      if (this.page - 1 >= 1) this.page = page;
    },
    updateItemsPerPage(number: number) {
      this.itemsPerPage = number;
    },
    openEdit() {
      const resourceEdit = (this as any).$refs.resourceEdit;
      resourceEdit.open();
    },
    cancel() {},
    open() {
      console.log();
    },
    close() {},
    addExhibitor(exhibitor: Exhibitor) {
      return this.createExhibitor(exhibitor)
        .then(() => {
          this.createSnack({ msg: 'Exhibitor Created', btnText: true });
        })
        .catch(err => {
          this.createSnack({
            msg: 'Failed to Create exhibitor' + ' ' + err,
            color: 'error',
            btnText: true
          });
        });
    },
    async destroyExhibitor(id: number) {
      const confirmDialog = this.$refs.confirmDialog;
      if (
        await confirmDialog.open('Delete Exhibitor?', {
          left: {
            text: 'Cancel'
          },
          right: {
            color: 'error',
            text: 'Delete',
            icon: 'mdi-delete',
            iconOnly: false
          }
        })
      ) {
        this.deleteExhibitor(id);
      } else {
        return;
      }
    },
    getSpeakerInitials(exhibitor: Exhibitor) {
      return exhibitor.name.substring(0, 1).toUpperCase();
    },
    getSpeakerFullName(exhibitor: Exhibitor) {
      return exhibitor.name;
    },

    addSpeaker() {}
  },

  mounted() {
    this.fetchExhibitors({
      event: localStorage.getItem('current__event')
    }).then(() => {
      console.log(this.exhibitors);
      console.log(this.orderedExhibitors);
      console.log(this.paginatedItems);

      this.fetchCategories({
        event: localStorage.getItem('current__event')
      }).then(res => {
        console.log({ res });
      });
      if (this.$route.query.search_query) {
        this.searchQuery = this.$route.query.search_query;
      }

      if (this.$route.query.itp) {
        if (this.itemsPerPageArray.includes(Number(this.$route.query.itp))) {
          this.itemsPerPage = this.$route.query.itp;
        } else {
          this.itemsPerPage = this.itemsPerPageArray[1];
        }
      }
      if (this.$route.query.sort_by) {
        const sort_object = find(this.sortItems, {
          value: this.$route.query.sort_by
        }) ?? { text: '', value: '' };
        if (this.sortItems.includes(sort_object)) {
          this.sort = this.$route.query.sort_by;
        } else {
          this.sort = this.sortItems[0].value;
        }
      }
      if (this.$route.query.page) {
        if (this.$route.query.page <= this.numberOfPages) {
          this.page = Number(this.$route.query.page);
        } else {
          this.page = 1;
        }
      }
    });
  }
});
